import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import { moviesData } from '@/mocks/movies';

export default function Home() {
  const featuredMovies = useMemo(
    () => moviesData.filter((m) => m.isHot).slice(0, 4),
    []
  );

  const movies = useMemo(
    () => moviesData.filter((m) => m.category === 'movie'),
    []
  );

  const tvShows = useMemo(
    () => moviesData.filter((m) => m.category === 'tv'),
    []
  );

  const varietyShows = useMemo(
    () => moviesData.filter((m) => m.category === 'variety'),
    []
  );

  const animes = useMemo(
    () => moviesData.filter((m) => m.category === 'anime'),
    []
  );

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '90影院 - 首页',
          description:
            '90影院汇聚8090影院电影、电视剧、综艺、动漫等最新热播影视，免费在线观看，高清不缓冲。',
          url: 'https://www.90cinema.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '90影院',
            url: 'https://www.90cinema.com/',
          },
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: moviesData.slice(0, 10).map((movie, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              item: {
                '@type': 'Movie',
                name: movie.title,
                url: `https://www.90cinema.com/detail/${movie.id}`,
                image: movie.coverImage,
                dateCreated: movie.releaseDate,
                director: { '@type': 'Person', name: movie.director },
              },
            })),
          },
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroBanner featuredMovies={featuredMovies} />

          <CategorySection />

          <FeaturedSection
            title="最新电影"
            subtitle="院线热映佳片，精彩不容错过"
            movies={movies}
            categoryKey="movie"
          />

          <FeaturedSection
            title="热播电视剧"
            subtitle="追剧不停歇，精彩剧情每日更新"
            movies={tvShows}
            categoryKey="tv"
          />

          <FeaturedSection
            title="热门综艺"
            subtitle="欢笑不断，轻松一刻从这里开始"
            movies={varietyShows}
            categoryKey="variety"
          />

          <FeaturedSection
            title="精彩动漫"
            subtitle="热血与感动，二次元的无限魅力"
            movies={animes}
            categoryKey="anime"
          />
        </main>

        <Footer />
      </div>
    </>
  );
}